var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer-overlay",class:[_vm.environmentClass, _vm.environmentClass === 'stage' ? 'btn-primary' : 'btn-danger']},[_c('strong',[_vm._v(_vm._s(_vm.environmentText))])])}
var staticRenderFns = []

export { render, staticRenderFns }